export const RESOURCE_NAME = 'invite';

export const ENTITY_NAME = 'invites';
